import { Control, ScaleLine, defaults, Attribution } from "ol/control";

const get_scale_control = () => {
  return new ScaleLine({
    units: "metric",
    bar: true,
    steps: 1,
    text: true,
    minWidth: 90,
    //className:"ol-scale-bar-custom"
  });
};

const get_default_controls = () => {
  const controls = defaults({
    zoom: false,
    attribution: false,
  });

  // Crear un nuevo control de atribución expandido
  const attributionControl = new Attribution({
    collapsible: false, // Esto lo mantiene expandido siempre
  });

  controls.push(get_scale_control());
  controls.push(attributionControl); // Agregar al conjunto de controles
  return controls;
};
export { get_default_controls };
